import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { colors, fonts } from "./";
export var normal = _objectSpread(_objectSpread({}, fonts["body-1"]), {}, {
  backgroundColor: colors.white,
  appearance: "none",
  transition: "box-shadow 200ms ease-in-out, background-color 200ms ease-in-out",
  border: "none",
  boxShadow: "0 0 0 0 transparent, 0 0 0 1px ".concat(colors.gray.buttonBorders, " inset")
});
export var hover = {
  boxShadow: "0 0 0 0 transparent, 0 0 0 1px ".concat(colors.blue.functional, " inset")
};
export var active = {
  zIndex: 1,
  outline: "none",
  boxShadow: "0 0 0 0 transparent, 0 0 0 2px ".concat(colors.blue.functional, " inset")
};
export var focus = {
  boxShadow: "0 0 0 2px ".concat(colors.blue.focusOutline, ", 0 0 0 2px ").concat(colors.blue.functional, " inset")
};
export var disabled = {
  background: colors.gray.bodyBackground,
  boxShadow: "0 0 0 0 transparent, inset 0 0 0 1px ".concat(colors.gray[60]),
  color: colors.gray.inkSubdued,
  cursor: "not-allowed"
};
export var invalid = {
  boxShadow: "0 0 0 0 transparent, inset 0 0 0 2px ".concat(colors.red[10])
};
export var invalidHover = {
  boxShadow: "0 0 0 0 transparent, inset 0 0 0 2px ".concat(colors.red.hover)
};